import React from 'react';
import { getRgbString } from '@tanium/coreui-utils';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion';
import { css, LayoutStyleProps } from '@tanium/style-system';
import { animation } from './animation';
import { FadeFill, PlaceholderFill } from './themeDefinitions';

export type Props = Pick<
  LayoutStyleProps,
  'height' | 'width' | 'minHeight' | 'minWidth' | 'maxHeight' | 'maxWidth'
>;

const ShimmerBox = styled(Box<'div'>)(
  css((theme) => ({
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: PlaceholderFill,
    '::after': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      content: '""',
      animation,
      transform: 'translateX(-100%)',
      backgroundImage: `linear-gradient(${[
        '90deg',
        `${getRgbString(FadeFill(theme), '0')} 0`,
        `${getRgbString(FadeFill(theme), '.2')} 7.5%`,
        `${getRgbString(FadeFill(theme), '.5')} 15%`,
        `${getRgbString(FadeFill(theme), '.2')} 22.5%`,
        `${getRgbString(FadeFill(theme), '0')} 30%`,
      ].join(',')})`,
    },
  })),
);

// This type cast provides better typings and Intellisense for consumers
export const Shimmer = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
  <ShimmerBox ref={ref} height="12px" width="75%" {...props} />
)) as React.VFC<Props & { ref?: React.Ref<HTMLDivElement> }>;
